/**
 * Full-screen "app is loading" fallback. Shared by App.jsx's route Suspense
 * boundaries and the route guards (e.g. WorkflowVisibilityRoute) so the loading
 * state has a single definition.
 */
const PageLoadingFallback = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    Loading DashONE...
  </div>
);

export default PageLoadingFallback;
